import React from "react";
import { SidebarMenu } from "./sidebar.dto";
import { NavLink } from "react-router-dom";
import "./sidebar.css";
import { FaChevronDown } from "react-icons/fa";
import { useSidebar } from "./sidebar.context";

function Sidebar() {
  const sidebarMenu = SidebarMenu;

  const { isSidebarOpen } = useSidebar();
  const { toggleSidebar } = useSidebar();
  const { childMenuOpen } = useSidebar();
  const { onClickParentMenu } = useSidebar();

  return (
    <div
      className={`sticky top-[72px] left-0 md:fixed md:w-52 z-50 bg-white transition-all duration-300 ease-in-out transform  ${
        isSidebarOpen ? "" : "md:-translate-x-full"
      } font-jakarta w-64 py-2 h-screen-minus-header border border-ys-pewter-500 border-t-0 border-l-0 shadow-sm overflow-auto`}
    >
      {sidebarMenu.map((menu) => (
        <div key={menu.path}>
          <NavLink
            onClick={() => onClickParentMenu(menu.name)}
            to={menu.path}
            className={({ isActive }) =>
              isActive && menu.children.length < 1
                ? "nav-link-active"
                : isActive && menu.children.length > 0
                ? "nav-link-active-and-has-child"
                : "nav-link-not-active"
            }
          >
            <div className="flex items-center">
              <span className="mr-2">{menu.icon}</span>
              <span>{menu.name}</span>
            </div>
            <span
              className={`${menu.children.length > 0 ? "" : "hidden"} ${
                childMenuOpen.includes(menu.name) ? "rotate-180" : "rotate-0"
              } transition-all duration-500 ease-in-out`}
            >
              <FaChevronDown />
            </span>
          </NavLink>

          {menu.children.length > 0 && (
            <div
              className={`parentHasChild ${
                childMenuOpen.includes(menu.name) ? "open" : "close"
              }`}
            >
              {menu.children.map((childMenu) => (
                <NavLink
                  key={childMenu.name}
                  to={childMenu.path}
                  onClick={() => toggleSidebar()}
                  className={({ isActive }) =>
                    isActive
                      ? "nav-link-child-active"
                      : "nav-link-child-not-active"
                  }
                >
                  <span>{childMenu.name}</span>
                </NavLink>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default Sidebar;
